import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CreateSecretInputClass;
function CreateSecretInput() {
  if (CreateSecretInputClass === VOID) {
    class $ {
      constructor(partyId, description) {
        this.f6p_1 = partyId;
        this.g6p_1 = description;
      }
      toString() {
        return 'CreateSecretInput(partyId=' + this.f6p_1.toString() + ', description=' + this.g6p_1 + ')';
      }
      hashCode() {
        var result = this.f6p_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.g6p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecretInput()))
          return false;
        if (!this.f6p_1.equals(other.f6p_1))
          return false;
        if (!(this.g6p_1 === other.g6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecretInput');
    CreateSecretInputClass = $;
  }
  return CreateSecretInputClass;
}
//region block: exports
export {
  CreateSecretInput as CreateSecretInput30co61ns422r9,
};
//endregion

//# sourceMappingURL=CreateSecretInput.mjs.map
